import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./components/Home";
import Projects from "./components/Projects";
import About from "./components/About";
import Contact from "./components/Contact";
import Blog from "./components/Blog";
import NavigationBar from "./components/NavigationBar";
import SinglePost from "./components/SinglePost";

// Set webpage's title on the browser tab
function App() {
  useEffect(() => {
    document.title = "Zelin Shu - My Personal Website";
  }, []);

  return (
    <BrowserRouter>
      <NavigationBar />
      <Switch>
        <Route component={Home} path="/" exact />
        <Route component={Projects} path="/projects" />
        <Route component={About} path="/about" />
        <Route component={Contact} path="/contact" />
        <Route component={SinglePost} path="/blog/:slug" />
        <Route component={Blog} path="/blog" />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
